




























































import { defineComponent, computed, toRefs } from '@vue/composition-api';
import VideoProcess from '@/components/common/video-process/index.vue';
import ViPlayIcon from '@tt4b/ttam-assets/src/svgs/vi-play.svg';
import TtamAdListItemTips from './item-tips.vue';
import TtamAdListItemOperateButtons from './item-operate-buttons.vue';

const name = 'ttam-ad-list-item';

export default defineComponent({
  name,

  components: {
    ViPlayIcon,
    VideoProcess,
    TtamAdListItemTips,
    TtamAdListItemOperateButtons,
  },

  props: {
    disabled: { type: Boolean, default: false },
    disabledHint: { type: String, default: '' },
    imageUrl: { type: String, default: '' },
    hasImage: { type: Boolean, default: true },
    hasVideo: { type: Boolean, default: true },
    /** 是否是当前 Ad */
    isActive: { type: Boolean, default: false },
    /** 整体 title */
    title: { type: String, default: '' },
    /** 素材 title */
    creativeTitle: { type: String, default: '' },
    /** video process 组件 props */
    videoProcessConfig: { type: Object, default: undefined },
    /** 是否可以修改素材名称 */
    isCanUpdateTitle: { type: Boolean, default: true },
    isShowVideoProcess: { type: Boolean, default: false },
    isShowMusicWarning: { type: Boolean, default: false },
    isShowValidateError: { type: Boolean, default: false },
    isShowPreCheckWarning: { type: Boolean, default: false },
    /** 是否是复制创意 */
    isCopyCreative: { type: Boolean, default: false },
    /** 是否禁用（隐藏）复制按钮 */
    disableCopy: { type: Boolean, default: false },
    /** 正在执行创意复制 */
    copyLoading: { type: Boolean, default: false },
    /** 当前创意正在执行复制 */
    isCopying: { type: Boolean, default: false },
    isPublished: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { isActive, isPublished } = toRefs(props);

    function onClick() {
      if (isPublished.value) {
        return;
      }
      emit('click');
    }

    function changeVideoName(videoName: string) {
      emit('change-video-name', videoName);
    }

    function handleCopy() {
      emit('copy');
    }

    function handleDelete() {
      emit('delete');
    }

    const className = computed(() => ({
      [name]: true,
      active: isActive.value,
      published: isPublished.value,
    }));

    return {
      name,
      onClick,
      handleCopy,
      handleDelete,
      changeVideoName,
      className,
    };
  },
});
